module.exports = __webpack_public_path__ + "static/media/henrysRestaurant.ba824db2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/henrysRestaurant.png
// module id = 46
// module chunks = 0